import { Typography, Box, Grid } from '@mui/material';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults as SEOSegmentationCaregiverSearchResult } from '@/__generated__/getSearchResults';
import { SEOSegmentationPageType } from '@/__generated__/globalTypes';
import { ReviewsCard } from './ReviewsCard';
import { Carousel } from '../common/Carousel';
import { usePageAttributes } from '../contexts/PageAttributesContext';
import { useResponsive } from '../hooks/useResponsive';

type ReviewsSectionProps = {
  caregiverSearchResults: SEOSegmentationCaregiverSearchResult[];
};

export const ReviewsSection = ({ caregiverSearchResults }: ReviewsSectionProps) => {
  const { segmentNamePluralLowerCase, city, state, pageType } = usePageAttributes();
  const { isSmallViewport } = useResponsive();

  const caregiverProfilesWithReviews = caregiverSearchResults
    .filter(
      (profile) =>
        profile.latestReview && profile.latestReview.comment && profile.latestReview.rating
    )
    .slice(0, 5);

  if (caregiverProfilesWithReviews.length < 3) {
    return null;
  }

  const nationalHeadline = `What others are saying about nearby ${segmentNamePluralLowerCase}`;
  const localHeadline = `What others are saying about ${segmentNamePluralLowerCase} in ${city}, ${state}`;
  const headline = pageType === SEOSegmentationPageType.NATIONAL ? nationalHeadline : localHeadline;

  return (
    <Grid item mt={{ xs: 6, md: 10 }} mb={{ xs: 6, md: 16 }} width="100%">
      <Typography component="h3" variant="h2" textAlign="center" mb={{ xs: 3, md: 6 }}>
        {headline}
      </Typography>
      <Box maxWidth={{ xs: '100%', sm: '80%', md: '85%', lg: '88%' }}>
        <Carousel
          showProgressIndicator
          itemsPerView={isSmallViewport ? 1 : 3}
          controlVariant={isSmallViewport ? 'none' : 'sides'}>
          {caregiverProfilesWithReviews.map(({ caregiver, latestReview }, index) => (
            <ReviewsCard
              key={`caregiver-review-${index + 1}`}
              revieweeName={caregiver.member.displayName}
              comment={latestReview?.comment ?? ''}
              rating={latestReview?.rating ?? 0}
              // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
              reviewerName={latestReview?.reviewer?.displayName || 'Care member'}
            />
          ))}
        </Carousel>
      </Box>
    </Grid>
  );
};
